"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var react_i18next_1 = require("react-i18next");

var fields_1 = require("../fields");

var react_web_components_1 = require("@nimles/react-web-components");

exports.SendQuoteForm = function (_a) {
  var onSubmit = _a.onSubmit;
  var values = {
    lines: [{
      description: 'des',
      price: 0
    }],
    description: ''
  };
  var t = react_i18next_1.useTranslation().t;

  var handleSubmit = function handleSubmit(values, _a) {
    var setSubmitting = _a.setSubmitting,
        setErrors = _a.setErrors,
        setStatus = _a.setStatus;
    return __awaiter(void 0, void 0, void 0, function () {
      var error_1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , onSubmit(values)];

          case 1:
            _b.sent();

            setSubmitting(false);
            setStatus({
              success: true
            });
            return [3
            /*break*/
            , 3];

          case 2:
            error_1 = _b.sent();
            setStatus({
              success: false
            });
            setSubmitting(false);
            setErrors({
              submit: error_1.message
            });
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return react_1.default.createElement(formik_1.Formik, {
    initialValues: values,
    onSubmit: handleSubmit,
    render: function render(_a) {
      var values = _a.values,
          handleSubmit = _a.handleSubmit,
          isSubmitting = _a.isSubmitting;
      return react_1.default.createElement("form", {
        onSubmit: handleSubmit,
        noValidate: true,
        name: "simpleForm"
      }, react_1.default.createElement(react_web_components_1.Column, null, react_1.default.createElement(fields_1.InputField, {
        name: "description",
        label: t('prop.description'),
        placeholder: t('prop.description'),
        value: values.description
      }), react_1.default.createElement(formik_1.FieldArray, {
        name: "lines",
        render: function render(arrayHelpers) {
          return react_1.default.createElement("div", null, values.lines.map(function (line, index) {
            return react_1.default.createElement(react_web_components_1.Row, {
              key: index
            }, react_1.default.createElement(react_web_components_1.Column, {
              flex: true
            }, react_1.default.createElement(fields_1.InputField, {
              name: "lines." + index + ".description",
              label: t('prop.description'),
              placeholder: t('prop.description'),
              value: line.description
            })), react_1.default.createElement(react_web_components_1.Column, {
              flex: true
            }, react_1.default.createElement(fields_1.InputField, {
              name: "lines." + index + ".price",
              label: t('prop.price'),
              placeholder: t('prop.price'),
              value: line.price
            })), react_1.default.createElement(react_web_components_1.Column, {
              flex: true
            }, react_1.default.createElement(react_web_components_1.Button, {
              type: "button",
              onClick: function onClick() {
                return arrayHelpers.remove(index);
              }
            }, "-")));
          }), react_1.default.createElement(react_web_components_1.Button, {
            type: "button",
            onClick: function onClick() {
              return arrayHelpers.push({
                description: '',
                price: 0
              });
            }
          }, t('action.addLine')));
        }
      })), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, null, react_1.default.createElement(react_web_components_1.Button, {
        type: "submit",
        className: "register-form__submit"
      }, t(isSubmitting ? 'action.sendingQuote' : 'action.sendQuote'), "Submit"))));
    }
  });
};